import { Link, NavLink, Outlet, useLocation, useSearchParams } from 'react-router';
import { SyncStatus } from './SyncStatus';

/**
 * SPEC §9 nav order (Map took Exploration's place, People came after it in M13, Gold took the
 * Ledger's in M15). Settings sits at the right of the header.
 */
export const NAV = [
  { to: '/', label: 'Tonight' },
  { to: '/book', label: 'Book' },
  { to: '/chronicle', label: 'Chronicle' },
  { to: '/map', label: 'Map' },
  { to: '/people', label: 'People' },
  { to: '/playtime', label: 'Playtime' },
  { to: '/gold', label: 'Gold' },
  { to: '/recipes', label: 'Recipes' },
  { to: '/digest', label: 'Digest' },
] as const;

function tabClass({ isActive }: { isActive: boolean }): string {
  const base = 'flex min-h-11 items-center px-3.5 no-underline';
  return isActive
    ? `${base} bg-accent font-semibold text-bg`
    : `${base} text-muted hover:text-text`;
}

export function Wordmark() {
  return (
    <Link
      to="/"
      className="font-mono text-wordmark font-semibold tracking-wordmark text-text no-underline"
    >
      BRIMSTONE
    </Link>
  );
}

export function AppShell() {
  const { pathname } = useLocation();
  const [params] = useSearchParams();
  // The map takes the whole screen under the header (its List view is a normal page).
  const fullScreen = /^\/map(\/|$)/.test(pathname) && params.get('view') !== 'list';
  return (
    <div className={fullScreen ? 'flex h-dvh flex-col' : undefined}>
      <header className="shrink-0 border-b border-line bg-header">
        <div className="mx-auto flex min-h-[60px] max-w-[1280px] flex-wrap items-center justify-between gap-x-6 gap-y-2 px-4 py-2 sm:px-6 lg:py-0">
          <div className="flex flex-wrap items-center gap-x-7 gap-y-2">
            <Wordmark />
            <nav aria-label="Sections" className="flex flex-wrap gap-0.5">
              {NAV.map((item) => (
                <NavLink key={item.to} to={item.to} end={item.to === '/'} className={tabClass}>
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <SyncStatus />
            <NavLink to="/settings" className={tabClass}>
              Settings
            </NavLink>
          </div>
        </div>
      </header>
      <main
        className={
          fullScreen ? 'relative min-h-0 flex-1' : 'mx-auto max-w-[1280px] px-4 py-6 sm:px-6'
        }
      >
        <Outlet />
      </main>
    </div>
  );
}
